import React, { useEffect, useState } from "react";
import { Card, CardBody, Container } from "reactstrap";
import { useSelector } from "react-redux";

import LoadingComponent from "components/LoadingComponent";
import { Text } from "components/Text";

import { InfoCard } from "./components/InfoCard";
import { ProgressBarFullScreen } from "./components/ProgressBarFullScreen";

import * as api from "services/api";

import {
	BarsContainer,
	DonutChartsContainer,
	InfoCardsContainer,
	InfosContainer
} from "./styles";
import { Flex } from "components/Flex";
import DateRangePickerComp from "components/DateRangePicker";
import dayjs from "dayjs";
import { Donut } from "components/ChartCardComp";
import { toStringCurrency } from "helpers/string";

export default function HirerDashboard({ company, companyId }) {
	const [isLoading, setIsLoading] = useState(true);
	const [licenseData, setLicenseData] = useState(null);
	const [contractsData, setContractsData] = useState(null);
	const [cnpjData, setCnpjData] = useState(null);
	const [cnpjStatusGraphData, setCnpjStatusGraphData] = useState([]);
	const [cnpjFederalStatus, setCnpjFederalStatus] = useState([]);
	const [nfStatus, setNfStatus] = useState(null);
	const [dasData, setDasData] = useState(null);
	const [dasStatusGraphData, setDasStatusGraphData] = useState(null);
	const [dasnData, setDasnData] = useState(null);
	const [dasnStatusGraphData, setDasnStatusGraphData] = useState(null);

	const [contractsFilter] = useState({});
	const [cnpjFilter] = useState({});
	const [nfFilter] = useState({});
	const [dasAndDasnFilter] = useState({});

	const { token } = useSelector(s => s.login);

	async function loadLicenseData() {
		try {
			const licenseResponse = await api.sendGet(
				`/companyProvider/get-status/${companyId}`,
				{
					Authorization: "Bearer " + token
				}
			);

			const licenseResult = await licenseResponse.json();

			if (licenseResult.isValid) {
				setLicenseData(licenseResult.model);
			}
		} catch (err) {
			console.log(err);
		}
	}

	async function loadContractsData() {
		let fill = "";
		for (const el of Object.keys(contractsFilter)) {
			fill += `&filters[${el}]=${contractsFilter[el]}`;
		}

		try {
			const contractStatusResponse = await api.sendGet(
				`/contracts/business-contract-status/${companyId}?${fill ||
					"&filters=null"}`,
				{
					Authorization: "Bearer " + token
				}
			);

			const contractStatusResult = await contractStatusResponse.json();

			if (contractStatusResult.isValid) {
				setContractsData(contractStatusResult.model);
			}
		} catch (err) {
			console.log(err);
		}
	}

	async function loadCnpjStatusData() {
		let fill = "";
		for (const el of Object.keys(cnpjFilter)) {
			fill += `&filters[${el}]=${cnpjFilter[el]}`;
		}

		try {
			const cnpjStatusResponse = await api.sendGet(
				`/company/providers-status/${companyId}?${fill || "filters=null"}`,
				{
					Authorization: "Bearer " + token
				}
			);

			const cnpjStatusResult = await cnpjStatusResponse.json();

			if (cnpjStatusResult.isValid) {
				setCnpjData(cnpjStatusResult.model);
			}
		} catch (err) {
			console.log(err);
		}
	}

	async function loadNfStatusData() {
		let fill = "";
		for (const el of Object.keys(nfFilter)) {
			fill += `&filters[${el}]=${nfFilter[el]}`;
		}

		try {
			const nfStatusResponse = await api.sendGet(
				`/company/nfse-status/${company._id}?${fill || "filters=null"}`,
				{
					Authorization: "Bearer " + token
				}
			);

			const nfStatusResult = await nfStatusResponse.json();

			if (nfStatusResult.isValid) {
				setNfStatus(nfStatusResult.model);
			}
		} catch (err) {
			console.log(err);
		}
	}

	async function loadDasStatusData() {
		let fill = "";
		for (const el of Object.keys(dasAndDasnFilter)) {
			fill += `&filters[${el}]=${dasAndDasnFilter[el]}`;
		}

		try {
			const dasStatusResponse = await api.sendGet(
				`/das/get-status-by-business/${companyId}?${fill || "filters=null"}`,
				{
					Authorization: "Bearer " + token
				}
			);

			const dasStatusResult = await dasStatusResponse.json();

			if (dasStatusResult.isValid) {
				setDasData(dasStatusResult.model);
			}
		} catch (err) {
			console.log(err);
		}
	}

	async function loadDasnStatusData() {
		let fill = "";
		for (const el of Object.keys(dasAndDasnFilter)) {
			fill += `&filters[${el}]=${dasAndDasnFilter[el]}`;
		}

		try {
			const dasnStatusResponse = await api.sendGet(
				`/dasn/get-status-by-business/${companyId}?${fill || "filters=null"}`,
				{
					Authorization: "Bearer " + token
				}
			);

			const dasnStatusResult = await dasnStatusResponse.json();

			if (dasnStatusResult.isValid) {
				setDasnData(dasnStatusResult.model);
			}
		} catch (err) {
			console.log(err);
		} finally {
			setIsLoading(false);
		}
	}

	async function loadData() {
		setIsLoading(true);

		loadLicenseData();
		loadContractsData();
		loadCnpjStatusData();
		loadNfStatusData();
		loadDasStatusData();
		loadDasnStatusData();
	}

	function createCnpjStatusGraphData() {
		let data = [];

		if (cnpjData?.registeredProvidersStatus?.active !== 0) {
			data.push({
				subtitle: "Ativo",
				title: `${(
					(cnpjData?.registeredProvidersStatus?.active * 100) /
					cnpjData?.registeredProvidersStatus?.total
				).toFixed(1)}%`,
				value: Number(
					(
						(cnpjData?.registeredProvidersStatus?.active * 100) /
						cnpjData?.registeredProvidersStatus?.total
					).toFixed(1)
				),
				color: "#409943"
			});
		}

		if (cnpjData?.registeredProvidersStatus?.pending !== 0) {
			data.push({
				subtitle: "Pendente",
				title: `${(
					(cnpjData?.registeredProvidersStatus?.pending * 100) /
					cnpjData?.registeredProvidersStatus?.total
				).toFixed(1)}%`,
				value: Number(
					(
						(cnpjData?.registeredProvidersStatus?.pending * 100) /
						cnpjData?.registeredProvidersStatus?.total
					).toFixed(1)
				),
				color: "#FE9A00"
			});
		}

		if (cnpjData?.registeredProvidersStatus?.inactive !== 0) {
			data.push({
				subtitle: "Inativo",
				title: `${(
					(cnpjData?.registeredProvidersStatus?.inactive * 100) /
					cnpjData?.registeredProvidersStatus?.total
				).toFixed(1)}%`,
				value: Number(
					(
						(cnpjData?.registeredProvidersStatus?.inactive * 100) /
						cnpjData?.registeredProvidersStatus?.total
					).toFixed(1)
				),
				color: "#FF2056"
			});
		}

		if (cnpjData?.registeredProvidersStatus?.onboarding !== 0) {
			data.push({
				subtitle: "Onboarding",
				title: `${(
					(cnpjData?.registeredProvidersStatus?.onboarding * 100) /
					cnpjData?.registeredProvidersStatus?.total
				).toFixed(1)}%`,
				value: Number(
					(
						(cnpjData?.registeredProvidersStatus?.onboarding * 100) /
						cnpjData?.registeredProvidersStatus?.total
					).toFixed(1)
				),
				color: "#29b6f6"
			});
		}

		setCnpjStatusGraphData(data);

		let cnpjFederalStatusData = [];

		if (cnpjData?.cnpjStatus?.active !== 0) {
			cnpjFederalStatusData.push({
				subtitle: "Ativo",
				title: `${(
					(cnpjData?.cnpjStatus?.active * 100) /
					cnpjData?.cnpjStatus?.total
				).toFixed(1)}%`,
				value: Number(
					(
						(cnpjData?.cnpjStatus?.active * 100) /
						cnpjData?.cnpjStatus?.total
					).toFixed(1)
				),
				color: "#409943"
			});
		}

		if (cnpjData?.cnpjStatus?.suspended !== 0) {
			cnpjFederalStatusData.push({
				subtitle: "Suspenso",
				title: `${(
					(cnpjData?.cnpjStatus?.suspended * 100) /
					cnpjData?.cnpjStatus?.total
				).toFixed(1)}%`,
				value: Number(
					(
						(cnpjData?.cnpjStatus?.suspended * 100) /
						cnpjData?.cnpjStatus?.total
					).toFixed(1)
				),
				color: "#FE9A00"
			});
		}

		if (cnpjData?.cnpjStatus?.unfit !== 0) {
			cnpjFederalStatusData.push({
				subtitle: "Inapto",
				title: `${(
					(cnpjData?.cnpjStatus?.unfit * 100) /
					cnpjData?.cnpjStatus?.total
				).toFixed(1)}%`,
				value: Number(
					(
						(cnpjData?.cnpjStatus?.unfit * 100) /
						cnpjData?.cnpjStatus?.total
					).toFixed(1)
				),
				color: "#FF2056"
			});
		}

		if (cnpjData?.cnpjStatus?.downloaded !== 0) {
			cnpjFederalStatusData.push({
				subtitle: "Baixado",
				title: `${(
					(cnpjData?.cnpjStatus?.downloaded * 100) /
					cnpjData?.cnpjStatus?.total
				).toFixed(1)}%`,
				value: Number(
					(
						(cnpjData?.cnpjStatus?.downloaded * 100) /
						cnpjData?.cnpjStatus?.total
					).toFixed(1)
				),
				color: "#71717B"
			});
		}

		setCnpjFederalStatus(cnpjFederalStatusData);
	}

	function createDasGraphData() {
		let data = [];

		if (dasData?.paid !== 0) {
			data.push({
				subtitle: "Liquidado",
				title: `${((dasData?.paid * 100) / dasData?.allDas).toFixed(1)}%`,
				value: Number(((dasData?.paid * 100) / dasData?.allDas).toFixed(1)),
				color: "#409943"
			});
		}

		if (dasData?.overDue !== 0) {
			data.push({
				subtitle: "Devedor",
				title: `${((dasData?.overDue * 100) / dasData?.allDas).toFixed(1)}%`,
				value: Number(((dasData?.overDue * 100) / dasData?.allDas).toFixed(1)),
				color: "#FF2056"
			});
		}

		if (dasData?.pending !== 0) {
			data.push({
				subtitle: "A vencer",
				title: `${((dasData?.pending * 100) / dasData?.allDas).toFixed(1)}%`,
				value: Number(((dasData?.pending * 100) / dasData?.allDas).toFixed(1)),
				color: "#FFB900"
			});
		}

		if (dasData?.notOpting !== 0) {
			data.push({
				subtitle: "Não Optante",
				title: `${((dasData?.notOpting * 100) / dasData?.allDas).toFixed(1)}%`,
				value: Number(
					((dasData?.notOpting * 100) / dasData?.allDas).toFixed(1)
				),
				color: "#FF6900"
			});
		}

		if (dasData?.unavailable !== 0) {
			data.push({
				subtitle: "Indisponível",
				title: `${((dasData?.unavailable * 100) / dasData?.allDas).toFixed(
					1
				)}%`,
				value: Number(
					((dasData?.unavailable * 100) / dasData?.allDas).toFixed(1)
				),
				color: "#AD46FF"
			});
		}

		if (dasData?.inInstallment !== 0) {
			data.push({
				subtitle: "Em parcelamento",
				title: `${((dasData?.inInstallment * 100) / dasData?.allDas).toFixed(
					1
				)}%`,
				value: Number(
					((dasData?.inInstallment * 100) / dasData?.allDas).toFixed(1)
				),
				color: "#31c2cb"
			});
		}

		setDasStatusGraphData(data);
	}

	function createDasnGraphData() {
		let data = [];

		if (dasnData?.done) {
			data.push({
				subtitle: "Retificar",
				title: `${((dasnData?.done * 100) / dasnData?.all).toFixed(1)}%`,
				value: Number(((dasnData?.done * 100) / dasnData?.all).toFixed(1)),
				color: "#409943"
			});
		}

		if (dasnData?.pending) {
			data.push({
				subtitle: "Declarar",
				title: `${((dasnData?.pending * 100) / dasnData?.all).toFixed(1)}%`,
				value: Number(((dasnData?.pending * 100) / dasnData?.all).toFixed(1)),
				color: "#FFB900"
			});
		}

		if (dasnData?.due) {
			data.push({
				subtitle: "Atrasado",
				title: `${((dasnData?.due * 100) / dasnData?.all).toFixed(1)}%`,
				value: Number(((dasnData?.due * 100) / dasnData?.all).toFixed(1)),
				color: "#FF2056"
			});
		}

		if (dasnData?.canceled) {
			data.push({
				subtitle: "Cancelado",
				title: `${((dasnData?.canceled * 100) / dasnData?.all).toFixed(1)}%`,
				value: Number(((dasnData?.canceled * 100) / dasnData?.all).toFixed(1)),
				color: "#4b4b4b"
			});
		}

		setDasnStatusGraphData(data);
	}

	function setFilterDateRangeOnTableContracts({ startDate, endDate }) {
		if (startDate) {
			contractsFilter["createdAtInitDate"] = dayjs(startDate).format(
				"DD/MM/YYYY"
			);
		} else {
			delete contractsFilter["createdAtInitDate"];
		}

		if (endDate) {
			contractsFilter["createdAtEndDate"] = dayjs(endDate).format("DD/MM/YYYY");
		} else {
			delete contractsFilter["createdAtEndDate"];
		}

		loadContractsData();
	}

	function setFilterDateRangeOnTableCnpj({ startDate, endDate }) {
		if (startDate) {
			cnpjFilter["createdAtInitDate"] = dayjs(startDate).format("DD/MM/YYYY");
		} else {
			delete cnpjFilter["createdAtInitDate"];
		}

		if (endDate) {
			cnpjFilter["createdAtEndDate"] = dayjs(endDate).format("DD/MM/YYYY");
		} else {
			delete cnpjFilter["createdAtEndDate"];
		}

		loadCnpjStatusData();
	}

	function setFilterDateRangeOnTableDasAndDasn({ startDate, endDate }) {
		if (startDate) {
			dasAndDasnFilter["createdAtInitDate"] = dayjs(startDate).format(
				"DD/MM/YYYY"
			);
		} else {
			delete dasAndDasnFilter["createdAtInitDate"];
		}

		if (endDate) {
			dasAndDasnFilter["createdAtEndDate"] = dayjs(endDate).format(
				"DD/MM/YYYY"
			);
		} else {
			delete dasAndDasnFilter["createdAtEndDate"];
		}

		loadDasStatusData();
		loadDasnStatusData();
	}

	function setFilterDateRangeOnTableNf({ startDate, endDate }) {
		if (startDate) {
			nfFilter["createdAtInitDate"] = dayjs(startDate).format("DD/MM/YYYY");
		} else {
			delete nfFilter["createdAtInitDate"];
		}

		if (endDate) {
			nfFilter["createdAtEndDate"] = dayjs(endDate).format("DD/MM/YYYY");
		} else {
			delete nfFilter["createdAtEndDate"];
		}

		loadNfStatusData();
	}

	useEffect(() => {
		loadData();
	}, []);

	useEffect(() => {
		createCnpjStatusGraphData();
	}, [cnpjData]);

	useEffect(() => {
		createDasGraphData();
	}, [dasData]);

	useEffect(() => {
		createDasnGraphData();
	}, [dasnData]);

	return (
		<Container className="dashboard">
			{isLoading ? (
				<LoadingComponent />
			) : (
				<>
					<Card style={{ height: "fit-content" }}>
						<CardBody>
							<InfosContainer>
								<Text fontSize="20px" lineHeight="23px" fontWeight={700}>
									Minha empresa
								</Text>

								<InfoCardsContainer>
									<InfoCard
										type="basic"
										title="Licenças contratadas"
										totalValue={
											company?.byMeasurement
												? "Ilimitado"
												: licenseData?.purchasedProviders ||
												  licenseData?.onboard + licenseData?.enabled ||
												  "--"
										}
									/>
									<InfoCard
										type={company?.byMeasurement ? "basic" : "used"}
										title="Licenças utilizadas"
										totalValue={
											company?.byMeasurement
												? licenseData?.onboard + licenseData?.enabled || "--"
												: licenseData?.purchasedProviders ||
												  licenseData?.onboard + licenseData?.enabled ||
												  "--"
										}
										totalUsed={
											licenseData?.onboard + licenseData?.enabled || "--"
										}
									/>
									<InfoCard
										type="status"
										title="Status da assinatura"
										status={licenseData?.status || 0}
									/>
								</InfoCardsContainer>

								{!company.useOwnContracts && (
									<Flex flexDirection="column" gap="16px">
										<Flex
											gap="16px"
											justifyContent="space-between"
											alignItems="center"
										>
											<Text fontSize="20px" lineHeight="23px" fontWeight={700}>
												Contratos
											</Text>

											<DateRangePickerComp
												onClose={setFilterDateRangeOnTableContracts}
											/>
										</Flex>

										<BarsContainer>
											<Text fontSize="18px" fontWeight={700} color="#303030">
												Status dos contratos
											</Text>

											<ProgressBarFullScreen
												label="Assinado"
												quantity={contractsData?.status.Signed}
												total={contractsData?.total}
											/>
											<ProgressBarFullScreen
												label="Pendente Contratante"
												quantity={contractsData?.pendingHirer}
												total={contractsData?.total}
											/>
											<ProgressBarFullScreen
												label="Pendente Prestador"
												quantity={contractsData?.pendingProvider}
												total={contractsData?.total}
											/>
											<ProgressBarFullScreen
												label="Cancelado"
												quantity={contractsData?.status.Cancelled}
												total={contractsData?.total}
											/>
										</BarsContainer>
									</Flex>
								)}
							</InfosContainer>
						</CardBody>
					</Card>

					<Card style={{ height: "fit-content" }}>
						<CardBody>
							<InfosContainer>
								<Flex
									gap="16px"
									justifyContent="space-between"
									alignItems="center"
								>
									<Text fontSize="20px" lineHeight="23px" fontWeight={700}>
										Prestadores
									</Text>

									<DateRangePickerComp
										onClose={setFilterDateRangeOnTableCnpj}
									/>
								</Flex>

								<Text fontSize="20px" lineHeight="23px" fontWeight={700}>
									CNPJs
								</Text>

								<InfoCardsContainer>
									<InfoCard
										type="basic"
										title="Prestadores Cadastrados"
										totalValue={cnpjData?.registeredProviders}
									/>
									<InfoCard
										type="basic"
										title="Prestadores Ativos"
										totalValue={cnpjData?.activeProviders}
									/>
									<InfoCard
										type="basic"
										title="Prestadores Ativos com CNPJ"
										totalValue={cnpjData?.providersWithCnpj}
									/>
								</InfoCardsContainer>

								<DonutChartsContainer>
									<Donut
										data={cnpjStatusGraphData}
										title="Status dos Prestadores Cadastrados (SuaMEi)"
										total={cnpjData?.registeredProvidersStatus.total}
									/>
									<Donut
										data={cnpjFederalStatus}
										title="Situação de CNPJs (Receita Federal)"
										total={cnpjData?.cnpjStatus.total}
									/>
								</DonutChartsContainer>

								<Flex
									gap="16px"
									justifyContent="space-between"
									alignItems="center"
								>
									<Text fontSize="20px" lineHeight="23px" fontWeight={700}>
										Notas fiscais
									</Text>

									<DateRangePickerComp onClose={setFilterDateRangeOnTableNf} />
								</Flex>

								<InfoCardsContainer>
									<InfoCard
										type="basic"
										title="Notas emitidas"
										totalValue={nfStatus?.nfsesMetrics?.totalIssued}
									/>
									<InfoCard
										type="basic"
										title="Valor médio das notas emitidas"
										totalValue={
											nfStatus?.nfsesMetrics
												? toStringCurrency(
														nfStatus.nfsesMetrics.averageValue / 100
												  )
												: "--"
										}
									/>
									<InfoCard
										type="basic"
										title="Média de notas emitidas por prestador"
										totalValue={nfStatus?.nfsesMetrics?.averagePerProvider}
									/>
								</InfoCardsContainer>

								<BarsContainer>
									<Text fontSize="18px" fontWeight={700} color="#303030">
										Emissões NFs
									</Text>

									<ProgressBarFullScreen
										label="Habilitados"
										quantity={nfStatus?.active}
										total={nfStatus?.total}
										color="#2e8e00"
									/>
									<ProgressBarFullScreen
										label="Habilitando"
										quantity={nfStatus?.activating}
										total={nfStatus?.total}
										color="#dcc600"
									/>
									<ProgressBarFullScreen
										label="Pendente"
										quantity={nfStatus?.pending}
										total={nfStatus?.total}
										color="#ff0000"
									/>
								</BarsContainer>

								<Flex
									gap="16px"
									justifyContent="space-between"
									alignItems="center"
								>
									<Text fontSize="20px" lineHeight="23px" fontWeight={700}>
										Impostos
									</Text>

									<DateRangePickerComp
										onClose={setFilterDateRangeOnTableDasAndDasn}
									/>
								</Flex>

								<DonutChartsContainer>
									<Donut
										data={dasStatusGraphData}
										title="DAS"
										total={dasData?.allDas}
									/>
									<Donut
										data={dasnStatusGraphData}
										title="DASN"
										total={dasnData?.all}
									/>
								</DonutChartsContainer>
							</InfosContainer>
						</CardBody>
					</Card>
				</>
			)}
		</Container>
	);
}
